<p>Этот сайт использует файлы cookie для хранения данных. Продолжая использовать сайт, Вы даёте своё согласие на работу с этими файлами.</p>
<div class="cookie-snackbar-container__buttons-list">
  <button mat-raised-button color="primary" class="button" type="button" (click)="accept()">Принять и закрыть</button>
</div>
